import React from 'react'
import ReactDOM from 'react-dom/client'
// 1. Importamos BrowserRouter
import { BrowserRouter } from 'react-dom/client' // OJO: a veces se importa de 'react-router-dom', revisa de dónde lo importas en tu App.js
import { BrowserRouter as Router } from 'react-router-dom' // <-- Esta es la importación correcta y más común

import App from './App'

import { LanguageProvider } from './utilities/LanguageContext' // Importa el proveedor del contexto
import { FloatMessageProvider } from './components/Providers/FloatMessage'

//import { GoogleOAuthProvider } from '@react-oauth/google'
import { StudentSocketProvider } from './components/Providers/StudentSocketProvider'
import { InstructorChatProvider } from './Support/Chat/Chat'
//import { BrowserRouter } from 'react-router'

const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<App />);

root.render(
  <React.StrictMode>
    {/* 2. Envolvemos TODO con el Router desde la raíz */}
    <Router>
      <LanguageProvider>
        <FloatMessageProvider>
          <StudentSocketProvider>
            <InstructorChatProvider>
              {/* <GoogleOAuthProvider clientId='559876239718-rccdkeaqoqopjq75mu7dm4rgauc3pvnn.apps.googleusercontent.com'> */}
              <App />
              {/* </GoogleOAuthProvider> */}
            </InstructorChatProvider>
          </StudentSocketProvider>
        </FloatMessageProvider>
      </LanguageProvider>
    </Router>
  </React.StrictMode>
);